/* eslint-disable react/prop-types */
import { Text } from "@chakra-ui/react";

const UserInfo = ({ children }) => {
  return (
    <Text fontSize="lg" lineHeight="xxl" fontWeight={600} color="white">
      {children}
    </Text>
  );
};

export default UserInfo;
